/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { AcceptInvitationMutationResponse, AcceptInvitationPathParams, AcceptInvitation400, AcceptInvitation401, AcceptInvitation403, AcceptInvitation404, AcceptInvitation409, AcceptInvitation500 } from "../../types/staffController/AcceptInvitation.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getAcceptInvitationUrl(token: AcceptInvitationPathParams["token"]) {
  const res = { method: 'POST', url: `/api/invitations/accept/${token}` as const }
  return res
}

/**
 * @summary Accept invitation
 * {@link /api/invitations/accept/:token}
 */
export async function acceptInvitation(token: AcceptInvitationPathParams["token"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AcceptInvitationMutationResponse, ResponseErrorConfig<AcceptInvitation400 | AcceptInvitation401 | AcceptInvitation403 | AcceptInvitation404 | AcceptInvitation409 | AcceptInvitation500>, unknown>({ method : "POST", url : getAcceptInvitationUrl(token).url.toString(), ... requestConfig })
  return res.data
}